// src/context/ShopDetailsContext.js
import { createContext, useContext, useState } from 'react';

const ShopDetailsContext = createContext();

export const useShopDetailsContext = () => useContext(ShopDetailsContext);

export const ShopDetailsProvider = ({ children }) => {
  const [shopDetailsContext, setShopDetailsContext] = useState({
    user_image: '',
    shop_name: '',
    meta_data: '',
    order_created_at: '',
    order_type: null
  });

  return (
    <ShopDetailsContext.Provider value={{ shopDetailsContext, setShopDetailsContext }}>
      {children}
    </ShopDetailsContext.Provider>
  );
};